import * as yup from "yup";

export const nameValidationSchema = yup.object().shape({
    name: yup.string()
        .required('Campo obbligatorio')
})

export const bedsValidationSchema = yup.object().shape({
    beds: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
})

export const sofaBedsValidationSchema = yup.object().shape({
    sofaBeds: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
})

export const extraBedsValidationSchema = yup.object().shape({
    extraBeds: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
})

export const mqValidationSchema = yup.object().shape({
    mq: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
})

export const numberOfBathroomValidationSchema = yup.object().shape({
    numberOfBathroom: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
})

